import React from "react";

const MergeReportViewer = ({ mergeReport, onViewPatient, onClose, onNewMerge, onViewHistory }) => {
  if (!mergeReport) {
    return (
      <div className="text-center py-5">
        <div className="alert alert-danger">
          <strong>Error:</strong> Merge report not available
        </div>
        <button className="btn btn-secondary mt-3" onClick={onClose}>
          Close
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="text-center mb-4">
        <div className="mb-3">
          <i className="fas fa-check-circle text-success" style={{ fontSize: "4rem" }}></i>
        </div>
        <h4 className="text-success">Merge Completed Successfully!</h4>
      </div>

      {/* Merge Summary */}
      <div className="card mb-4">
        <div className="card-header bg-success text-white">
          <strong>Merge Summary</strong>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Merge Log ID:</strong> {mergeReport.merge_log_id?.substring(0, 8)}...</p>
              <p><strong>Status:</strong> <span className="badge bg-success">{mergeReport.status}</span></p>
            </div>
            <div className="col-md-6">
              <p><strong>Visits Transferred:</strong> {mergeReport.visits_transferred || 0}</p>
              <p><strong>Completed At:</strong> {mergeReport.merge_summary?.merged_at || 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>

      {/* What Happened */}
      <div className="card mb-4">
        <div className="card-header">
          <strong>What Happened</strong>
        </div>
        <div className="card-body">
          <ul>
            <li>All visits from the secondary patient have been transferred to the primary patient</li>
            <li>All charts, documents, and medical data have been merged</li>
            <li>The secondary patient record has been archived</li>
            <li>A merge audit log has been created for tracking</li>
          </ul>
        </div>
      </div>

      {/* Next Steps */}
      <div className="alert alert-info">
        <strong>Next Steps:</strong>
        <ul className="mb-0 mt-2">
          <li>Review the merged patient record to verify all data is correct</li>
          <li>Check that all visits are accessible</li>
          <li>Verify all charts and documents are linked correctly</li>
        </ul>
      </div>

      {/* Action Buttons */}
      <div className="d-flex justify-content-center gap-2 mt-4">
        <button className="btn btn-primary" onClick={onViewPatient}>
          View Merged Patient
        </button>
        <button className="btn btn-info" onClick={() => onViewHistory && onViewHistory(mergeReport.primary_employee_id || mergeReport.merge_summary?.primary_employee_id)}>
          <i className="fas fa-history me-1"></i> View Merge History
        </button>
        <button className="btn btn-secondary" onClick={onNewMerge}>
          Merge Another
        </button>
        <button className="btn btn-outline-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default MergeReportViewer;

